// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__1GE6s"};